import '@fontsource/inter/variable.css';
import React from 'react';
import { GlobalProvider } from './src/context/GlobalContext';
import { initializeSDK, initializeDesignSystem, initializePlatform, initializePendo } from './src/utils/initializers';

export const onClientEntry = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const designSystemOnly = urlParams.has('design-system');

    (window as TectonWindow).Tecton = {
        PLATFORM_VERSION: '',
        FI_IDENTIFIER: '',
        TECTON_PLATFORM_VERSION: '0.10.0',
        TECTON_SDK_VERSION: '0.10.0',
        inMobileApp: false,
        noStrings: false,
        useActionSheets: false,
        platformDimensions: {},
        platformUrl: '',
    };

    if (designSystemOnly) {
        console.log('Initializing Tecton Design System');
        await initializeDesignSystem();
    } else {
        console.log('Initializing Tecton Platform and SDK');
        await initializePlatform();
        await initializeSDK();
    }
    if (window.location.hostname === 'localhost') return;
    initializePendo();
};

export const onInitialClientRender = async () => {
    const urlHash = window.location.hash;
    if (!urlHash) return;

    const element = document.querySelector(urlHash);
    if (!element) return;
    const tabPane = element?.closest('q2-tab-pane');
    if (tabPane) {
        const tabContainer = tabPane.closest('q2-tab-container');
        tabContainer?.setAttribute('value', tabPane.value);

        if (!tabContainer?.hasAttribute('stencil-hydrated')) {
            await new Promise(resolve => tabContainer?.addEventListener('settled', resolve, { once: true }));
        }
    }
    element.scrollIntoView();
};

export const wrapRootElement = ({ element }: { element: JSX.Element }) => <GlobalProvider>{element}</GlobalProvider>;

export const disableCorePrefetching = () => true;
